import { databases } from "@/lib/appwrite";
import { Query } from "appwrite";

export async function getUserSessionsAndBreaks(userId: string, date?: string) {
  const dbId = import.meta.env.VITE_APPWRITE_DATABASE_ID;
  const sessionColl = import.meta.env.VITE_WORK_SESSIONS_COLLECTION_ID;
  const breakColl = import.meta.env.VITE_WORK_BREAKS_COLLECTION_ID;

  const queries: string[] = [Query.equal("userId", userId)];

  if (date) {
    // Use local midnight boundaries so sessions at 19:00+ (UTC-5) aren't pushed to the next UTC day
    const startOfDay = new Date(`${date}T00:00:00`).toISOString();
    const endOfDay   = new Date(`${date}T23:59:59.999`).toISOString();

    queries.push(
      Query.greaterThanEqual("clockIn", startOfDay),
      Query.lessThanEqual("clockIn", endOfDay)
    );
  }

  const sessions = await databases.listDocuments(dbId, sessionColl, queries);

  if (sessions.documents.length === 0) {
    return [];
  }

  // traer todas las ids de las sesiones
  const sessionIds = sessions.documents.map(session => session.$id);

  // Solo obtener breaks 
  const allBreaks = await databases.listDocuments(dbId, breakColl, [
    Query.equal("workSessionId", sessionIds),
  ]);

  // agrupar breaks por sessionId
  const breaksBySession = allBreaks.documents.reduce((acc, breakDoc) => {
    const sessionId = breakDoc.workSessionId;
    if (!acc[sessionId]) acc[sessionId] = [];
    acc[sessionId].push(breakDoc);
    return acc;
  }, {} as Record<string, any[]>);

  // combinar con breaks unicamente
  const sessionsWithBreaks = sessions.documents.map((session) => ({
    ...session,
    breaks: breaksBySession[session.$id] || [],
    notes: [], // Inicialmente vacío
    hasNotesLoaded: false // Flag para saber si ya cargamos las notas
  }));

  return sessionsWithBreaks;
}

// nueva funcion para cargar notas bajo demanda
export async function getSessionNotes(sessionId: string) {
  const dbId = import.meta.env.VITE_APPWRITE_DATABASE_ID;
  const notesColl = import.meta.env.VITE_WORK_SESSION_NOTES_COLLECTION_ID;

  const notes = await databases.listDocuments(dbId, notesColl, [
    Query.equal("sessionId", sessionId),
    Query.orderDesc("createdAt")
  ]);

  return notes.documents as unknown as {
    $id: string;
    userId: string;
    sessionId: string;
    noteContent: string;
    createdAt: string;
    updatedAt?: string;
    isRead: boolean;
  }[];



}

// Funcion para eliminar una nota
export async function deleteNote(noteId: string) {
  const dbId = import.meta.env.VITE_APPWRITE_DATABASE_ID;
  const notesColl = import.meta.env.VITE_WORK_SESSION_NOTES_COLLECTION_ID;

  try {
    await databases.deleteDocument(dbId, notesColl, noteId);
    return { success: true };
  } catch (error) {
    console.error("Error deleting note:", error);
    throw error;
  }
}